// 表格更改过滤
export function changeFilteredInfo(searchArr){
    let filter={}
    searchArr.map(item=>{
        filter[item.key]=[item.value]
    })
    return filter
}
